import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { Controller, type Control, type FieldErrors, type FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as consts from "../constants";

const FormGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
}));

type ContactMethodFieldsProps = {
  control: Control<FieldValues>;
  errors: FieldErrors<FieldValues>;
  watchedContactMethod?: string;
};

export default function ContactMethodFields(props: ContactMethodFieldsProps) {
  const { control, errors, watchedContactMethod } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormGrid size={{ xs: 12, md: 6 }}>
        <FormLabel id="contact_method" required>
          {t("contactMethodTitle")}
        </FormLabel>
        <Controller
          name="contact_method"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Select {...field}>
              <MenuItem value={consts.contactMethod.PHONE}>{t("contactMethodPhoneOption")}</MenuItem>
              <MenuItem value={consts.contactMethod.WECHAT}>{t("contactMethodWechatOption")}</MenuItem>
              <MenuItem value={consts.contactMethod.LINE}>{t("contactMethodLineOption")}</MenuItem>
            </Select>
          )}
        />
      </FormGrid>
      {watchedContactMethod === consts.contactMethod.WECHAT && (
        <FormGrid size={{ xs: 12, md: 6 }}>
          <FormLabel id="contact_details" required>
            {t("contactDetails")}
          </FormLabel>
          <Controller
            name="wechat_id"
            control={control}
            rules={{
              validate: (v) => {
                if (watchedContactMethod !== consts.contactMethod.WECHAT) return true;
                if (!v?.trim()) return t("errWechatRequired");
                return v.trim().length <= 64 || t("errMaxLength64");
              },
            }}
            render={({ field }) => (
              <TextField
                aria-labelledby="wechat_id"
                error={!!errors.wechat_id}
                helperText={errors.wechat_id ? String(errors.wechat_id.message ?? "") : t("contactDetailsHint")}
                placeholder={t("contactDetailsWechatPlaceholder")}
                inputProps={{ maxLength: 64 }}
                {...field}
              />
            )}
          />
        </FormGrid>
      )}
      {watchedContactMethod === consts.contactMethod.LINE && (
        <FormGrid size={{ xs: 12, md: 6 }}>
          <FormLabel id="contact_details" required>
            {t("contactDetails")}
          </FormLabel>
          <Controller
            name="line_id"
            control={control}
            rules={{
              validate: (v) => {
                if (watchedContactMethod !== consts.contactMethod.LINE) return true;
                if (!v?.trim()) return t("errLineRequired");
                return v.trim().length <= 64 || t("errMaxLength64");
              },
            }}
            render={({ field }) => (
              <TextField
                aria-labelledby="line_id"
                error={!!errors.line_id}
                helperText={errors.line_id ? String(errors.line_id.message ?? "") : t("contactDetailsHint")}
                placeholder={t("contactDetailsLinePlaceholder")}
                inputProps={{ maxLength: 64 }}
                {...field}
              />
            )}
          />
        </FormGrid>
      )}
    </>
  );
}
